<template>
<!-- Article -->
  <section class="body-2 ma-0">
    <span v-if="article.journal" class="pa-0">{{article.journal}}</span><span 
      		v-if="article.volume" class=" pa-0 font-weight-bold"> {{article.volume}}</span><span 
				v-if="article.number" class="pa-0"> ({{article.number}})</span><span 
    				v-if="article.volume" class="pa-0">, </span><span 
						v-if="year==2100" class="pa-0">, to appear</span><span 
						v-if="year < 2100" class="pa-0">{{year}}</span><span 
							v-if="article.page_from" class="pa-0">, {{article.page_from}}</span><span 
							v-if="article.page_to" class="pa-0">-{{article.page_to}}.</span>
  </section>
</template>
<script>
export default {
  props:['article','year'],
}
</script>

